import { toError } from 'utils/errors';
import logger from 'utils/logger';

type RefetchLoyaltyUser = () => Promise<unknown>;

export const refetchLoyaltyUserSafely = (
  refetchLoyaltyUser: RefetchLoyaltyUser,
  source: string
): void => {
  void refetchLoyaltyUser().catch(error => {
    logger.error({
      error: toError(error),
      message: `Error refreshing loyalty user from ${source}`,
    });
  });
};
